module.exports = __webpack_public_path__ + "img/140.a481ea8b.jpg";